import { render, staticRenderFns } from "./RadioTags.vue?vue&type=template&id=6de98db6&scoped=true&"
import script from "./RadioTags.vue?vue&type=script&lang=js&"
export * from "./RadioTags.vue?vue&type=script&lang=js&"
import style0 from "./RadioTags.vue?vue&type=style&index=0&id=6de98db6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de98db6",
  null
  
)

export default component.exports